import * as React from 'react'

import { Divider, NewsBody, NewsHead } from './Styles'

type Props = {
  head: string
  body: string
}

export default class ProjectNews extends React.Component<Props> {
  render() {
    const { head, body } = this.props
    return (
      <div>
        <NewsHead key={'head'}>{head}</NewsHead>
        <NewsBody key={'body'}>{body}</NewsBody>
        <Divider />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/Projects/ProjectNews.tsx